import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Checkbox from 'material-ui/Checkbox';
import { CircularProgress } from 'material-ui/Progress';
import Button from 'material-ui/Button';
import IconButton from 'material-ui/IconButton';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Switch from 'material-ui/Switch';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import ContainerHeader from '../../../components/ContainerHeader/index';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import * as addUserDetails from '../../../actions/userdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';
import * as lookup from '../../../actions/lookup';
import * as toaster from '../../../actions/toaster';
import * as fileupload from '../../../actions/fileupload';

import UserRequest from '../../../api/requests/UserRequest'

import { clone, filter, find, fill, includes, map, some, zipObject, property, remove } from 'lodash'


import AddRole from "./addrole";
import * as regData from '../../../../appConstants'

class AddUser extends Component {

    constructor(props) {
        super(props)
        this.state = {
            id: this.props.params.id,
            u_id: this.props.params.u_id,
            valueSet: false,
            valueSetPhoto: false,
            deleteRoleCommittee_id: null,
            user: { id: '', user_id: '', user_name: '', email_id: '', isBadmin: false, isChecker: false, ad_user: false, userRoleCommittee: [], pendingRoleCommittee: [], photo: null, user_nameAD: null, },
            newfile: null,
            isFileUploaded: false,
            userPhoto: null,
        }
    }

    handleChange(field, e) {
        if (field == 'isBadmin' || field == 'isChecker') {
            let user = Object.assign({}, this.state.user, { [field]: e.target.checked });
            if (field == 'isBadmin' && e.target.checked)
                user = Object.assign({}, user, { 'isChecker': false });
            if (field == 'isChecker' && e.target.checked)
                user = Object.assign({}, user, { 'isBadmin': false });
            this.setState(Object.assign({}, this.state, { user }));
            // console.log('this.state', this.state);
        }
        else if (field == 'ad_user') {
            let user = Object.assign({}, this.state.user, { [field]: e.target.checked });
            this.setState(Object.assign({}, this.state, { user }));
            // console.log('this.state', this.state);
        }
        else {
            const user = Object.assign({}, this.state.user, { [field]: e.target.value });
            this.setState(Object.assign({}, this.state, { user }));
        }
        // console.log(this.state)
    };

    handleSelectPhoto(e) {
        var fileList = document.getElementById("image").files;
        var fileReader = new FileReader();
        if (fileReader && fileList && fileList.length) {
            fileReader.readAsArrayBuffer(fileList[0]);
            fileReader.onload = function () {
                var imageData = fileReader.result;
            };
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        // console.log("user", this.state.user)
        var uUser = this.state.user;
        uUser.ad_user = uUser.ad_user ? 1 : 0;
        if (uUser.id) {
            //Filter to extract newly added roles
            let nRoles = uUser.userRoleCommittee
            uUser.userRoleCommittee = filter(nRoles, { 'roles': [{ 'id': '-1' }] });
            this.props.actions.updateUserDetails(uUser);
        }
        else
            this.props.actions.addUserDetails(uUser);
    };

    getAddRoleData = (data) => {
        // console.log("getAddRoleData", data);
        let _rolefound = false;
        let _committeefound = find(this.state.user.userRoleCommittee, { "committee_id": data.committee_id });
        if (_committeefound) {
            // console.log('data.role', data.role)
            // console.log("_committeefound", _committeefound);
            _rolefound = some(_committeefound.roles, (v) => includes(data.role, v.role_id));
            // console.log('_rolefound', _rolefound)
        }
        if (!_rolefound) {
            let _roles = [];
            data.role.map((_data, index) => {
                _roles.push({ 'id': '-1', 'role_id': _data })
            })
           // this.state.user.userRoleCommittee.push({ committee_id: data.committee_id, roles: _roles });
           this.state.user.userRoleCommittee.push({ committee_id: data.committee_id,rid:_roles[0].role_id, roles: _roles });
            const user = Object.assign({}, this.state.user, { ['userRoleCommittee']: this.state.user.userRoleCommittee });

            this.setState(Object.assign({}, this.state, { user }));
            // console.log("this.state.userRole", this.state.userRole);
        }
        else
            this.props.actions.warningToasters('User Role is already assigned');
        data = null;
    }

    getRolesList(_array, _RoleList) {
        let res = filter(_RoleList, (v) => find(_array, { 'role_id': v.id }));
        // console.log('_array',_array)
        // console.log('res',res)
        return map(res, 'name').join(",");
    }

    onDeleteUserRole = (urole, e) => {
        let _urole = urole.roles;
        let com = this.state.user.userRoleCommittee
        if (filter(_urole, { 'id': '-1' }).length > 0) {
           // remove(com, { 'committee_id': urole.committee_id })
            remove(com, { 'rid': urole.rid,'committee_id':urole.committee_id })
            this.setState(Object.assign({}, this.state.user, { 'userRoleCommittee': com }));
        }
        else {
            this.props.actions.deleteUserRole(this.state.id, map(_urole, property('id')));
            this.setState({ deleteRoleCommittee_id: urole.committee_id })
        }
    };

    handleFileSelected(file) {

        var reader = new FileReader();
        var url = reader.readAsDataURL(file.target.files[0]);

        reader.onloadend = function (e) {
            this.setState({
                userPhoto: [reader.result]
            })
        }.bind(this);
        let formData = new FormData();
        formData.append('file', file.target.files[0])
        this.props.actions.photoUpload(formData)
        this.setState({ isFileUploaded: true, valueSetPhoto: true });
        this.refs.fileUpload.value = null;
    }

    getUserAD = () => {
        if (this.state.user.user_nameAD && this.state.user.user_nameAD.length > 0) {
            this.setState({ id: 1, valueSet: false });
            if (!this.state.id) {
                let userAD = this.state.user;
                userAD.user_id = '';
                userAD.user_name = '';
                userAD.email_id = '';
            }
            // this.props.actions.getUserDetails(this.state.user.user_nameAD);
            this.props.actions.getUserAD(this.state.user.user_nameAD);
        }
        else {
            this.props.actions.warningToasters('User Id is Mandatory');
        }
    }
    componentDidMount() {
        // console.log('props', this.props)
        this.setState({ userPhoto: null });
        if (this.state.id) {
            this.props.actions.getUserDetails(this.state.id);
            this.props.actions.photoDownload(this.state.u_id);
            this.setState({ valueSetPhoto: true });
        }
        else
            this.state.user = { id: '', user_id: '', user_name: '', email_id: '', isBadmin: false, isChecker: false, ad_user: false, userRoleCommittee: [], pendingRoleCommittee: [], user_nameAD: null, }
        this.props.actions.getAddUserRoleLookup();
        this.props.actions.loadswitchercommittees();
    }
    render() {
        const { match, getAddUserRoleLookup, teamDetails, userDetails, loginUser, fileupload, getCustomer } = this.props;
        let RoleList = getAddUserRoleLookup.lookupList;
        let CommitteeList = teamDetails.switchteamdetailsList;
        let UserRoleList = null;
        let PendingUserRoleList = null;
        let result = null;
        // console.log('props', this.props.fileupload)
        if ((getAddUserRoleLookup && getAddUserRoleLookup.Status) || (teamDetails && teamDetails.Status)
            || (fileupload && fileupload.Status) || (userDetails && userDetails.Status) || (userDetails && userDetails.actionStatus)) {
            result = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        if (teamDetails && teamDetails.switchteamdetailsList)
            CommitteeList = teamDetails.switchteamdetailsList;
        if (getAddUserRoleLookup && getAddUserRoleLookup.lookupList)
            RoleList = getAddUserRoleLookup.lookupList;
        // console.log('userDetails.Userdetails', userDetails.Userdetails);
        // console.log('this.state.id', this.state.id)
        // console.log('this.state.valueSet', this.state.valueSet)
        if (userDetails && userDetails.Userdetails && userDetails.Userdetails.id && this.state.id && !this.state.valueSet) {
            console.log('userDetails.Userdetails', userDetails.Userdetails);
            if (userDetails.Userdetails.id != '-1') {//-1 == Response of GetUserAD method
                this.state.id = userDetails.Userdetails.id;
                userDetails.Userdetails.ad_user = userDetails.Userdetails.ad_user == 1 ? true : false;
                this.setState({ user: userDetails.Userdetails, valueSet: true });
            }
            else {
                this.state.id = null;
                let userAD = this.state.user;
                userAD.user_id = userDetails.Userdetails.userId;
                userAD.user_name = userDetails.Userdetails.userName;
                userAD.email_id = userDetails.Userdetails.emailId;
                this.setState({ user: userAD, valueSet: true });
            }
            // console.log('this.state = ', this.state)
        }
        if (this.state.user.ad_user && this.state.id > 0) {
            this.state.user.user_nameAD = this.state.user.user_name;
        }
        if (this.state.user.userRoleCommittee) {
            UserRoleList = this.state.user.userRoleCommittee.map((_data, index) => {
                let committeeItem = find(CommitteeList, { "id": _data.committee_id });
                // console.log(committeeItem)
                if (committeeItem)
                    return (<tr key={index}>
                        <td>{index + 1}</td>
                        <td>{committeeItem.name}</td>
                        <td>{this.getRolesList(_data.roles, RoleList)}</td>
                        {loginUser.data.role_id != "2" ? null : <td><IconButton onClick={this.onDeleteUserRole.bind(this, _data)}><i className="zmdi zmdi-delete" /></IconButton></td>}
                    </tr>);
            });
        }
        if (this.state.user.pendingRoleCommittee) {
            PendingUserRoleList = this.state.user.pendingRoleCommittee.map((_data, index) => {
                let PcommitteeItem = find(CommitteeList, { "id": _data.committee_id });
                // console.log(committeeItem)
                if (PcommitteeItem)
                    return (<tr key={index}>
                        <td>{index + 1}</td>
                        <td>{PcommitteeItem.name}</td>
                        <td>{this.getRolesList(_data.roles, RoleList)}</td>
                        {/* <td></td> */}
                    </tr>);
            });
        }
        if (fileupload && fileupload.filedetails && this.state.isFileUploaded) {
            // console.log('After upload success',this.state.newfile)
            // this.props.actions.photoDownload(this.state.u_id);
            this.state.user.photo = fileupload.filedetails;
            this.setState({ isFileUploaded: false, newfile: '' });
            // console.log('After upload success', this.state.user)
        }
        if (this.state.valueSetPhoto && fileupload && fileupload.userPhoto && !this.state.userPhoto) {
            // console.log('After upload success',this.state.newfile)
            // this.refs.img.getDOMNode().src = "data:image/png;base64, " + fileupload.userPhoto;
            this.state.userPhoto = "data:image/png;base64, " + fileupload.userPhoto;
            this.setState({ valueSetPhoto: false });
            // console.log('After upload success', this.state.user)
        }
        if (userDetails && userDetails.actionResult && this.state.deleteRoleCommittee_id) {
            // console.log('After upload success',this.state.newfile)
            remove(this.state.user.userRoleCommittee, { 'committee_id': this.state.deleteRoleCommittee_id })
            this.setState({ deleteRoleCommittee_id: null, });
            // console.log('After upload success', this.state.user)
        }

        return (
            <div className="slideInUpTiny">
                {result}
                <ContainerHeader title="Add User" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <ValidatorForm autoComplete="off" onSubmit={this.handleSubmit.bind(this)}>
                            <Card className="shadow border-0">
                                <CardHeader className="bg-primary text-white">User Details</CardHeader>
                                <CardBody>
                                    <div className="row">
                                        {getCustomer.isCheckerEnabled && getCustomer.isCheckerEnabled.isAD_enabled && getCustomer.isCheckerEnabled.isAD_enabled == 1 ?
                                            <div className="col-md-2 col-12">
                                                <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }}
                                                    checked={this.state.user.ad_user} onChange={this.handleChange.bind(this, 'ad_user')} />
                                                } label="AD User" />
                                            </div>
                                            : null}
                                        {this.state.user.ad_user ?
                                            <div className="col-md-10 col-12">
                                                <TextValidator type="text" margin="normal" className="mt-0 mr-2 col-6"
                                                    name="user_nameAD" label="User Id" disabled={this.state.user.id ? true : false}
                                                    value={this.state.user.user_nameAD} onChange={this.handleChange.bind(this, 'user_nameAD')} />
                                                <Button variant="raised" onClick={this.getUserAD.bind(this)} className="jr-btn bg-primary text-white">Fetch User Details</Button>
                                            </div>
                                            :
                                            <div className="col-md-10 col-12"></div>
                                        }
                                        <div className='row'>
                                        <div className="col-sm-3">  
                                        <img src={this.state.userPhoto ? this.state.userPhoto : 'ProfilePic.png'} className="ppicture" />
                                            <input ref="img" type="file" accept="image/*" id="fileUpload" ref="fileUpload" className="hidden" onChange={this.handleFileSelected.bind(this)} />
                                            <label htmlFor="fileUpload" className="w77">
                                                <Button variant="raised" component="span" className="jr-btn bg-primary text-white">Add Photo</Button>
                                            </label>
                                            
                                            {/* <label className="m-2">{this.state.newfile && this.state.newfile.file ? this.state.newfile.file.name : "No file chosen"}</label> */}
                                        </div>
                                        <div className="col-sm-9 pr-5">
                                            <div class='row'>

                                            <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="userName" label="User Name"
                                                validators={['required', regData.regexAlphaNumeric, regData.regexAlphaNumericLength]}
                                                errorMessages={['This field is required', regData.messageAlphaNumeric, regData.messageLength]}
                                                value={this.state.user.user_name} onChange={this.handleChange.bind(this, 'user_name')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-4 col-12"
                                                name="userId" label="User Id" disabled={this.state.user.id || this.state.user.ad_user ? true : false}
                                                validators={['required', regData.regexUserName, regData.regexUserNameLength]}
                                                errorMessages={['This field is required', regData.messageAlphaNumeric, regData.messageLength]}
                                                value={this.state.user.user_id} onChange={this.handleChange.bind(this, 'user_id')} />
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <TextValidator type="text" margin="normal" className="mt-0 mb-2 col-12"
                                                name="email" label="Email Address" disabled={this.state.user.ad_user}
                                                validators={['required', 'isEmail']}
                                                errorMessages={['This field is required', 'email is not valid']}
                                                value={this.state.user.email_id} onChange={this.handleChange.bind(this, 'email_id')} />
                                        </div>
                                       
                                        <div className="col-md-6 col-12">
                                            <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }}
                                                checked={this.state.user.isBadmin} onChange={this.handleChange.bind(this, 'isBadmin')} />
                                            } label="IT Admin" />
                                            {getCustomer.isCheckerEnabled && getCustomer.isCheckerEnabled.ischecker_enabled && getCustomer.isCheckerEnabled.ischecker_enabled == 1 ? <FormControlLabel control={<Switch classes={{ checked: 'text-primary', bar: 'bg-primary', }}
                                                checked={this.state.user.isChecker} onChange={this.handleChange.bind(this, 'isChecker')} />
                                            } label="Checker" /> : null}
                                        </div>

                                            </div>
                                        </div>
                                        </div>
                              

                                      
                                    </div>
                                </CardBody>
                            </Card>
                            <Card className="">
                                <CardBody>
                                    <div className="row">
                                        
                                        <div class="row custrow w-100 justify-content-between">
                                        <h3 className="card-title col-sm-6 custtitle">Assign Roles</h3>
                                        {loginUser.data.role_id != "2" ? null : <AddRole roleList={RoleList} committeeList={CommitteeList} setAddRoleData={this.getAddRoleData} />}
                                        </div>
                                        

                                        <div className="col-md-12">
                                            

                                            <div className="table-responsive-material hideoverflow">
                                                <table className="default-table table-unbordered table table-lg table-hover">
                                                    <thead className="th-border-b">
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Team Name</th>
                                                            <th>User Roles</th>
                                                            {loginUser.data.role_id != "2" ? null : <th className="status-cell">Actions</th>}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {UserRoleList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card className={(this.state.user.pendingRoleCommittee && this.state.user.pendingRoleCommittee.length > 0) ? "shadow border-2" : "hidden"}>
                                <CardBody>
                                    <div className="row">
                                        <h3 className="card-title">Approval Pending Roles</h3>
                                        <div className="col-md-12">
                                            <div className="table-responsive-material">
                                                <table className="default-table table-unbordered table table-lg table-hover">
                                                    <thead className="th-border-b">
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Team Name</th>
                                                            <th>User Roles</th>
                                                            {/* <th className="status-cell">Actions</th> */}
                                                            {/* <th /> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {PendingUserRoleList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="col-12 text-right">
                                {loginUser.data.role_id != "2" ? null : <Button type='submit' variant="raised" className="jr-btn bg-primary text-white">Save</Button>}
                                <Button variant="raised" className="jr-btn bg-grey text-white"
                                    onClick={() => { loginUser.data.role_id != "2" ? this.props.history.push('/user/meeting-user-list') : this.props.history.push('/user/user-list') }}>Cancel</Button>
                            </div>
                        </ValidatorForm>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    // console.log(state)
    const { userDetails, getAddUserRoleLookup, teamDetails, loginUser, fileupload, getCustomer } = state
    const { match } = ownProps
    return { match, userDetails, getAddUserRoleLookup, teamDetails, params: ownProps.match.params, loginUser, fileupload, getCustomer }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, fileupload, addUserDetails, loadswitchercommittees, lookup, toaster), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AddUser);



// WEBPACK FOOTER //
// ./app/userdetails/adduser/index.js